/** 左侧导航快捷键；输入法、AltGraph、额外组合键与长按不能误切换。 */
export function isSidebarToggleShortcut(event: KeyboardEvent, acceptRepeat = false): boolean {
  return !event.defaultPrevented && !event.isComposing && event.keyCode !== 229
    && (!event.repeat || acceptRepeat) && !event.getModifierState?.('AltGraph')
    && event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey
    && event.key.toLowerCase() === 't'
}
